import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import { CommonModule, Location } from "@angular/common";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-user-guide",
  templateUrl: "./guide.html",
  styleUrls: ["./user-guide.component.scss"],
  standalone: true,
  imports: [CommonModule],
})
export class UserGuideComponent implements AfterViewInit, OnDestroy {
  tocOpen = false;
  version = environment.version;

  private observer?: IntersectionObserver;

  constructor(
    private location: Location,
    private host: ElementRef<HTMLElement>,
  ) {}

  ngAfterViewInit(): void {
    const root = this.host.nativeElement;
    const links = Array.from(root.querySelectorAll<HTMLAnchorElement>(".toc a"));
    const byId = new Map(
      links
        .map((a) => [a.getAttribute("href")?.slice(1) ?? "", a] as const)
        .filter(([id]) => !!id),
    );

    const scroller = root.querySelector("main");
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          links.forEach((link) => link.classList.remove("active"));
          byId.get(entry.target.id)?.classList.add("active");
        }
      },
      { root: scroller, rootMargin: "-24px 0px -70% 0px" },
    );

    root
      .querySelectorAll<HTMLElement>("section[id], .stage[id], #intro")
      .forEach((section) => this.observer?.observe(section));

    const hash = window.location.hash.slice(1);
    if (hash) {
      document.getElementById(hash)?.scrollIntoView({ block: "start" });
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  goBack(): void {
    this.location.back();
  }

  toggleToc(): void {
    this.tocOpen = !this.tocOpen;
  }

  scrollTo(event: Event, id: string): void {
    event.preventDefault();
    this.tocOpen = false;
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
